import { render, staticRenderFns } from "./addCpn.vue?vue&type=template&id=0735bfd4"
import script from "./addCpn.vue?vue&type=script&lang=js"
export * from "./addCpn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports